import React, { useEffect, useState } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { useParams } from 'react-router-dom';
import { Button, Col, Form, Row, Modal } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import CustomDateInput from 'components/common/CustomDateInput';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import fr from 'date-fns/locale/fr';
import { useFormatDate } from 'hooks';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { isEqual, isObject, transform } from 'lodash';
import { API_URL } from 'constants';
import Newucrm from '../crm/New';
import { typehome } from 'config';


const EditDemand = () => {
    const { id } = useParams();
    registerLocale('fr', fr);
    setDefaultLocale('fr');
    const [showModal, setShowModal] = useState(false);
    const [isDnDMode, setIsDnDMode] = useState(false);
    const [valueClientId, setValueClientId] = React.useState(null);
    const [valueVilla, setValueVilla] = React.useState(null);
    const [valueVillaPossible, setValueVillaPossible] = React.useState([]);
    const [valueStatut, setValueStatut] = React.useState(null);
    const [valueOrigin, setValueOrigin] = React.useState(null);
    const [validated, setValidated] = React.useState(false);
    const [valueDemande, setValueDemande] = React.useState(null);
    const [formd, setFrom] = React.useState({});
    const [mac, setMac] = React.useState({});
    const [l, setL] = React.useState(false);
    const [is_moral, setMoral] = React.useState(false);
    const [is_owner, setIs_Owner] = React.useState(false);
    const [clients, setClients] = React.useState([]);
    const [checkIn, setCheckIn] = React.useState(null);
    const [checkOut, setCheckOut] = React.useState(null);
    const [demand_date, setDemand_Date] = React.useState(new Date());
    const [booked_date, setBooked_Date] = React.useState(new Date());
    const [emails, setEmails] = React.useState('');
    const [disabledClientId, setDisableclientId] = React.useState(false);
    const [lsendE, setLsendE] = React.useState(false);
    const [villas, setVilla] = React.useState([]);

    const [valueInterlocuteur, setValueInterlocuteur] = React.useState(null);
    const [interlocuteurs, setInterlocuteur] = React.useState([]);
    const [logs, setLogs] = React.useState([]);
    const [users, setUsers] = React.useState([]);


    const [valueEquipment, setValueEquipment] = React.useState([]);
    const [equipements, setEquipements] = React.useState([]);
    const [services, setServices] = React.useState([]);
    const [servicesList, setServicesList] = React.useState([]);



    const getLogs = () => {
        firebase.firestore().collection(`demands/${id}/logs`)
            .orderBy('date', 'desc')
            .get().then((ls) => {
                let s = [];
                ls.forEach((d) => {
                    let e = d.data()
                    e.id = d.id;
                    s.push(e)
                })

                setLogs(s);

            }).catch((error) => {
                setL(false);
                var errorMessage = error.message;
                toast.error(errorMessage);
            })

    }
    const loadUsers = () => {
        firebase.firestore().collection('users').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                var l = d.data();
                if (l?.delete) {
                    // supprimer donc ne pas affiché
                } else {
                    if (l?.type === "admin") {
                        const dr = { value: d.id, label: `${l?.lastName} ${l?.firstName}`, phone: l.phone, email: l.email, picture_profile: l.picture_profile }
                        s.push(dr)
                    }
                }

            })
            setInterlocuteur(s);
        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })
    }

    const loadList = () => {

        getLogs();


        // get list clients and format
        firebase.firestore().collection('equiments').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                let e = '';
                const dr = { value: d.id, label: d.data()?.title }
                s.push(dr)
            })
            setEquipements(s);

        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })

        firebase.firestore().collection('services').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                let e = '';
                const dr = { value: d.id, label: d.data()?.title }
                s.push(dr)
            })
            setServicesList(s);

        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })
    }



    const navigate = useNavigate();


    // const loadVilla = () => {
    //     firebase.firestore().collection('properties').get().then((snap) => {
    //         let s = [];
    //         snap.forEach((d) => {
    //             var l = d.data();
    //             if (l?.delete) {
    //                 // supprimer donc ne pas affiché
    //             } else {
    //                 const dr = { value: d.id, label: `${l?.nameHouse}`, data: l }
    //                 s.push(dr)
    //             }

    //         })
    //         setVilla(s);
    //     }).catch((error) => {
    //         setL(false);
    //         var errorMessage = error.message;
    //         toast.error(errorMessage);
    //     })
    // }



    const getPriceForMonth = (monthValue, priceList) => {
        const season = priceList.find(season =>
            season?.months.some(month => month?.value === monthValue)
        );

        let price = null;

        if (season) {
            price = season.price;
        } else {
            // Sinon, trouve le prix le plus bas dans toute la liste
            const minPrice = Math.min(...priceList.map(season => parseFloat(season.price)));
            price = minPrice;
        }

        // Formater le prix avec des milliers séparés par un point
        const formattedPrice = new Intl.NumberFormat('fr-FR').format(price)
            .replace(/\s/g, '.') + '€'; // Remplace l'espace par un point

        return formattedPrice;
    };


    function difference(object, base) {
        function changes(object, base) {
            return transform(object, function (result, value, key) {
                if (!isEqual(value, base[key])) {
                    result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value;
                }
            });
        }
        return changes(object, base);
    }
    function isValidDate(dateString) {
        // Attempt to create a Date object from the input string
        var date = new Date(dateString);

        // Check if the date is valid
        // "Invalid Date" is the string returned by Date object for an invalid date
        // Also, make sure the input string is not equal to the default date (1970-01-01)
        return date.toString() !== 'Invalid Date' && !isNaN(date);
    }


    function initializevilla(client) {
        const idc = client.lang;
        let d = formd
        d?.villaPossible?.forEach((dr) => {
            if (d[dr.label + '_info'] === undefined) {

                let drs = villas.find((vs) => vs.value === dr.value)
                const dsdate = d.checkin?.seconds ? d.checkin.toDate() : new Date(d.checkin)
                const mdsdate = dsdate.getMonth() + 1;

                const lastdate = formd.checkout?.seconds ? formd.checkout.toDate() : new Date(formd.checkout)

                const price = getPriceForMonth(mdsdate, drs.data?.prices);
                let type = drs.data.type.label;
                let thEn = typehome.find((l) => l.label === type).en?.toLowerCase();
                let p = "La ";
                switch (type) {
                    case 'Appartement':
                        p = "L'";
                        break;
                    case 'Chalet':
                        p = "Le ";
                        break;
                    default:
                        break;
                }

                d[drs.label + '_info'] = idc === 'fr' ? `${p}${type?.toLowerCase()} ${drs.label} est disponible ${formatDisponibilite(dsdate, lastdate, "fr-FR")} pour ${price ? price : "Non trouvé"} par semaine.` : `The ${thEn} ${drs.label} is available from ${formatDisponibilite(dsdate, lastdate, "en-US")} for ${price ? price : "Non trouvé"} per week`

            }
        })
        setTimeout(() => {
            delete d.initializevilla;
            setFrom(d)
        }, 200);
    }
    useEffect(() => {
        const fetchData = async () => {
            if (!id) {
                toast.error("Une erreur s'est produite.");
                return;
            }



            let s = [];

            let snap = await firebase.firestore().collection('crm').get()
            snap.forEach((d) => {
                let e = '';
                let pre = d.data()?.email?.split(',') || []
                pre.forEach((s) => {
                    e += `${s}, `;
                })
                // console.log("d.data()", d.data()?.lang?.value)
                const dr = { value: d.id, label: `${d.data()?.lastName} ${d.data()?.firstName}`, email: e, lang: d.data()?.lang?.value || 'fr' }
                if (d.data()?.delete) { }
                else {
                    s.push(dr)
                }
            })
            setClients(s);
            // loadVilla();
            let villaasnap = await firebase.firestore().collection('properties').get()
            let svilla = [];
            villaasnap.forEach((d) => {
                var l = d.data();
                if (l?.delete) {
                    // supprimer donc ne pas affiché
                } else {
                    const dr = { value: d.id, label: `${l?.nameHouse}`, data: l }
                    svilla.push(dr)
                }

            })
            setVilla(svilla);

            loadList();
            getAllUser();
            loadUsers();
            firebase.firestore().collection('demands').doc(id).get().then(doc => {
                if (doc) {
                    let d = doc.data()
                    setMac(doc.data())
                    d.id = doc.id;
                    d.email = d?.emails?.join(', ') || '';
                    setValueClientId(d.client)
                    setValueVilla(d.property)
                    setValueStatut(d.statut)
                    setValueOrigin(d.origin)
                    setValueDemande(d.numberDemand);
                    // console.log('d', d); 
                    if (d?.checkin != null && typeof d?.checkin === 'string' && isValidDate(d?.checkin)) {
                        setCheckIn(new Date(d?.checkin))
                    } else {
                        if (d?.checkin != null && d?.checkin != null && d?.checkin.toDate !== undefined && isValidDate(d?.checkin.toDate())) {
                            setCheckIn(d?.checkin.toDate())
                        }
                    }
                    setDemand_Date(d.demand_date?.toDate());
                    // console.log('s', d)
                    if (d?.checkout != null && typeof d?.checkout === 'string' && isValidDate(d?.checkout)) {
                        setCheckOut(new Date(d?.checkout))
                    } else {
                        if (d?.checkout != null && d?.checkout.toDate !== undefined && isValidDate(d?.checkout.toDate())) {
                            setCheckOut(d?.checkout.toDate())
                        }
                    }
                    setBooked_Date(d?.booked_date?.toDate());
                    setEmails(d?.emails?.join(', ') || '')
                    setDisableclientId(d?.client ? true : false);
                    setValueEquipment(d?.equipments || [])
                    setServices(d?.services || []);
                    setValueVillaPossible(d?.villaPossible || []);
                    setValueInterlocuteur(d?.interlocuteur || null)

                    setFrom(d)
                }
            })
        };

        fetchData();
    }, [id]);



    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity() === false) {
            console.log('error', formd)
            toast.error('Champs obligatoire manquant.')
            return;
        }

        if (l) {
            return;
        }

        var t = formd
        t.checkin = checkIn;
        t.checkout = checkOut;
        t.booked_date = booked_date;
        t._update_At = new Date();
        t.guest = {
            firstName: t?.client?.label.split(' ')[1],
            lastName: t?.client?.label.split(' ')[0]
        }
        let dds = t?.email?.split(',');
        let sd = []
        dds?.forEach(s => {
            if (validateEmail(s?.trim())) {
                sd.push(s?.trim());
            }
        })
        t.emails = sd;
        let al = t.email
        // delete t.email;
        delete t.id;


        if (t.checkout === undefined) {
            delete t.checkout;
        }
        if (t.checkin === undefined) {
            delete t.checkin;
        }
        if (t.booked_date === undefined) {
            delete t.booked_date;
        }


        setValidated(true);
        setL(true);



        if (valueStatut.value === "booked") {
            let res = window.confirm("La demande sera transformé en réservation, continuer ?")
            if (res) {
                t.statut = { value: 'confirmed', label: 'Confirmer' };
                t.canEdit = false;

                firebase.firestore().collection('demands').get().then((snap) => {
                    let s = [];
                    snap.forEach((d) => {
                        var l = d.data();
                        s.push(l)
                    })
                    const nb = s.length + 1
                    t.numberDemand = { value: id, label: `N° ${nb} - ${t.client.label} - ${t.property.label}` };

                    try {
                        firebase.firestore().collection('bookings').add(t).then((doc) => {
                            console.log("Document successfully written!");
                            toast.success("Réservation créer avec succès a partir de la demande");
                            t.bookedId = doc.id;
                            let sd = {
                                statut: "Vers réservation",
                                date: new Date(),
                                data: null,
                                uid: firebase.auth().currentUser.uid
                            }
                            firebase.firestore().collection(`demands/${id}/logs`).add(sd)

                            let sdd = {
                                statut: "created",
                                date: new Date(),
                                data: t,
                                uid: firebase.auth().currentUser.uid
                            }
                            firebase.firestore().collection(`bookings/${doc.id}/logs`).add(sdd)

                            firebase.firestore().collection('demands').doc(id).update(t).then(() => {
                                navigate('/booking/edit/' + doc.id);
                            });
                        }).catch((error) => {
                            setL(false);
                            var errorMessage = error.message;
                            toast.error(errorMessage);
                            t.email = al
                        })
                    } catch (error) {
                        setL(false);
                        t.email = al
                        var errorMessage = error.message;
                        toast.error(errorMessage);
                    }
                })
            } else {
                toast.error("Mise à jour, annulé");
            }
        } else {

            delete t._create_At;
            delete t.demand_date;

            // console.log('info', t);
            try {
                firebase.firestore().collection('demands').doc(id).update(t).then(() => {

                    let mc = difference(t, mac);
                    delete mc._update_At;
                    delete mc._create_At;
                    delete mc.emails;
                    delete mc.checkin;
                    delete mc.checkout;
                    delete mc.booked_date;

                    // console.log("mc", mc)
                    let sd = {
                        statut: "Modification",
                        date: new Date(),
                        data: JSON.stringify(mc),
                        uid: firebase.auth().currentUser.uid
                    }
                    firebase.firestore().collection(`demands/${id}/logs`).add(sd)


                    console.log("Document successfully written!");
                    toast.success("Demande modifié avec succès");
                    navigate(`/demand/edit/${id}`);
                    setL(false);
                    getLogs()

                }).catch((error) => {
                    setL(false);
                    console.log('error ici', error)
                    var errorMessage = error.message;
                    toast.error(errorMessage);
                    t.email = al
                })
            } catch (error) {
                setL(false);
                console.log('error', error)
                t.email = al
                var errorMessage = error.message;
                toast.error(errorMessage);
            }
        }

    };
    // Fonction pour gérer le Drag and Drop
    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(valueVillaPossible);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setValueVillaPossible(items);

        let d = { ...formd };
        d["villaPossible"] = items;
        setFrom(d);
    };


    const handleChange = e => {
        let d = { ...formd };
        // console.log(e.target.name, e.target?.checked,e.target?.value ); 
        if (e.target.name === "is_owner") {
            d[e.target.name] = e.target.checked;
            setIs_Owner(e.target.checked)
        } else {
            if (e.target.name === "type") {
                d[e.target.name] = e.target.value === "moral" ? "moral" : "physique";
                setMoral(e.target.value === "moral")
            } else {
                d[e.target.name] = e.target.value;
                if (e.target.name === "email") {
                    setEmails(e.target.value)
                }
            }
        }
        setFrom(d);
    };

    const getUser = (uid) => {
        let d = ""
        users.forEach(u => {
            if (u.value === uid) {
                d = u.label
            }
        })
        return d
    }

    const getAllUser = async () => {
        await firebase.firestore()
            .collection("users")
            .get().then((snap) => {
                let s = [];
                snap.forEach((d) => {
                    var l = d.data();
                    if (l?.delete) {
                        // supprimer donc ne pas affiché
                    } else {
                        const dr = { value: d.id, label: `${l?.lastName} ${l?.firstName}` }
                        s.push(dr)
                    }
                    setUsers(s);
                })
            })
            .catch((error) => {
                console.log("error", error);
            });
    };


    const columns = [
        {
            accessor: 'statut',
            Header: 'Statut',
        },
        {
            accessor: 'uid',
            Header: 'Qui',
            Cell: ({ row }) => (
                <>
                    <span>{getUser(row.original.uid)}</span>
                </>
            )
        },
        {
            accessor: 'date',
            Header: 'Date',
            headerProps: { className: 'text-900' },
            Cell: ({ row }) => (
                <>{row?.original?.date && row?.original?.date?.toDate !== undefined && (
                    <small className="has-text-grey is-abbr-like">
                        {useFormatDate(row.original?.date?.toDate(), {
                            day: 'numeric',
                            weekday: 'short',
                            year: 'numeric',
                            month: 'short',
                        })}
                    </small>
                )}
                </>
            )
        },
        {
            accessor: 'data',
            Header: 'Donnée(s)',
            Cell: ({ row }) => (
                <>
                    {row.original?.statut !== 'Création' && (
                        <pre>{row?.original?.data && JSON.stringify(JSON.parse(row?.original?.data), null, 2)}</pre>
                    )}
                </>
            )
        }
    ]

    function LogTable() {
        if (l) {
            return <p>Chargement...</p>
        }

        return (<AdvanceTableWrapper
            columns={columns}
            data={logs}
            sortable
            pagination
            perPage={205}>
            <AdvanceTable
                table
                headerClassName="bg-200 text-nowrap align-middle"
                rowClassName="align-middle white-space-nowrap"
                tableProps={{
                    bordered: true,
                    striped: true,
                    className: 'fs--1 mb-0 overflow-hidden'
                }}
            />
            <div className="mt-3">
                <AdvanceTableFooter
                    rowCount={logs.length}
                    table
                    rowInfo
                    navButtons
                    rowsPerPageSelection
                />
            </div>
        </AdvanceTableWrapper>)
    }
    const formatDisponibilite = (checkin, checkout, sts) => {
        const optionsJour = { day: 'numeric' };
        const optionsMois = { month: 'long' };

        const jourCheckin = checkin.toLocaleDateString(sts, optionsJour);
        const moisCheckin = checkin.toLocaleDateString(sts, optionsMois);
        const jourCheckout = checkout.toLocaleDateString(sts, optionsJour);
        const moisCheckout = checkout.toLocaleDateString(sts, optionsMois);

        // Vérifie si le mois est différent entre checkin et checkout
        if (moisCheckin !== moisCheckout) {
            return `${jourCheckin} ${moisCheckin} ${sts === 'fr-FR' ? 'au' : 'to'} ${jourCheckout} ${moisCheckout}`;
        } else {
            return `${jourCheckin} ${sts === 'fr-FR' ? 'au' : 'to'} ${jourCheckout} ${moisCheckout}`;
        }
    };

    const getInfo = (property) => {
        let infos = [];
        property?.forEach((p) => {
            let ps = `${p?.nameHouse}_info`;
            infos.push({ id: p?.id, info: formd[ps] });
        });
        return infos;
    }


    const generatePDF = () => {
        if (lsendE) {
            return;
        }
        let property = []
        valueVillaPossible?.forEach((ps) => {
            villas?.forEach((p) => {
                if (p.data && ps.value === p.value) {
                    let d = p.data;
                    d.id = p.value
                    property.push(d);
                }
            })
        })
        // console.log('formd?.client', formd?.client?.value)
        let lang = 'fr';
        clients?.forEach((c) => {
            if (c.value === formd?.client?.value) {
                lang = c.lang;
            }
        })
        if (formd?.client && property.length > 0) {

            if (formd?.emails) {
                let em = formd?.emails;
                if (em.length > 0) {

                    let blanche = false;
                    if (confirm('Envoyer en marque blanche ? cliquer sur Annuler pour envoyer avec le logo')) {
                        blanche = true;
                    }
                    let inter = null;
                    interlocuteurs?.forEach((si) => {
                        if (si.value === formd.interlocuteur?.value) {
                            inter = si
                        }
                    })
                    if (inter === null) {
                        toast.error('Interlocuteur non trouvé')
                        return;
                    }

                    // Demande le sujet de l'email à l'utilisateur
                    const subject = prompt("Veuillez entrer le sujet de l'email :");

                    // Vérifie si un sujet a été saisi
                    if (subject) {
                        console.log("Sujet de l'email :", subject);


                        const infos = getInfo(property);
                        // envoie du mail
                        setLsendE(true)
                        try {
                            fetch(`${API_URL}sendEmailDemandList`, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ name: formd?.client?.label ? (formd?.client?.label || '').split(' ').filter(Boolean).reverse().join(' ').replace('undefined', '') : '', subject: subject, blanche: blanche, list: property, client: em, lang: lang, infos: infos, replyto: firebase.auth().currentUser?.email, interlocuteur: inter }),
                            }).then((res) => res.json())
                                .then(async (data) => {
                                    //   console.log("data", data);
                                    setLsendE(false)
                                    if (data.success) {
                                        let sd = {
                                            statut: "Envoie email liste des biens au client",
                                            date: new Date(),
                                            data: JSON.stringify({ emails: em, property: valueVillaPossible }),
                                            uid: firebase.auth().currentUser.uid
                                        }
                                        toast.success("Envoie de l'email réussi")
                                        await firebase.firestore().collection(`demands/${id}/logs`).add(sd)
                                        getLogs()
                                    } else {
                                        toast.error("Envoie de l'email non réussi")
                                        console.error(data?.error)
                                    }
                                })
                        } catch (err) {
                            toast.error("Envoie de l'email non réussi" + err)
                            console.error(err)
                            setLsendE(false)

                        }

                    } else {
                        return;
                    }

                }
            }
        }


        // let sd = {
        //     statut : "Génération interne",
        //     date: new Date(),
        //     data: JSON.stringify({info : "Rapport de la demande"}),
        //     uid : firebase.auth().currentUser.uid
        // }  
        // firebase.firestore().collection(`demands/${id}/logs`).add(sd)
        // getLogs()
    }


    // const generatePDFClient = () => {
    //     alert('En cours de développement');

    //     let sd = {
    //         statut: "Génération client",
    //         date: new Date(),
    //         data: JSON.stringify({ info: "Rapport pour le client (liste des villas et de la demande)" }),
    //         uid: firebase.auth().currentUser.uid
    //     }
    //     firebase.firestore().collection(`demands/${id}/logs`).add(sd)
    //     getLogs()
    // }

    return (<>
        <FalconComponentCard>
            <FalconComponentCard.Header title={`${formd?.canEdit === false ? 'Visualisation' : 'Edition'} de la demande - ${id}`} light={false} noPreview={true} />
            <FalconComponentCard.Body >
                {formd?.client || formd?.bySearch ? (
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>

                        <Row className="mb-3">
                            <Form.Group as={Col} md="5" controlId="bookingorder">
                                <Form.Label>Client (requis)</Form.Label>
                                <Select
                                    required
                                    options={clients}
                                    placeholder={clients.length === 0 ? 'Chargement...' : 'Choisir le client...'}
                                    classNamePrefix="react-select"
                                    value={valueClientId}
                                    isDisabled={formd?.canEdit === false || disabledClientId}
                                    onChange={value => {
                                        let d = formd;
                                        d['client'] = value;
                                        setFrom(d);
                                        if (valueClientId?.value !== value.value) {
                                            // si changement de client on efface email et on réinit
                                            let f = formd
                                            f['email'] = undefined;
                                            setFrom(f);
                                            setEmails('')
                                        }
                                        setValueClientId(value)
                                        if (formd['email'] === undefined) {
                                            let id = value.value
                                            clients.forEach(d => {
                                                if (d.value === id) {
                                                    let f = formd
                                                    f['email'] = d.email
                                                    setFrom(f);
                                                    setEmails(d.email)
                                                }
                                            })
                                        }

                                        if (formd.initializevilla) {
                                            initializevilla(value)
                                        }

                                    }
                                    }
                                />
                                {formd && formd.client && <p><a href={`/crm/edit/${formd?.client?.value}`} target='_blank'>Voir le client</a></p>}
                                {formd && formd.client === undefined && <p><a href={`#`} onClick={() => setShowModal(true)}  >Nouveau client</a></p>}

                            </Form.Group>
                            <Form.Group as={Col} md="5" controlId="villa">
                                <Form.Label>Propriété</Form.Label>
                                <Select
                                    options={villas}
                                    placeholder='Choisir la villa...'
                                    classNamePrefix="react-select"
                                    value={valueVilla}
                                    onChange={value => {
                                        setValueVilla(value)
                                        let d = formd;
                                        d['property'] = value;
                                        setFrom(d);

                                    }}
                                    isDisabled={formd?.canEdit === false}
                                />{valueVilla && <p><a href={`/demand/pdf/${id}`} target='_blank'>Générer contrat pdf</a></p>}
                            </Form.Group>
                        </Row>

                        <Row className="mb-3">
                            <Form.Group as={Col} md="5" controlId="interlocuteur">
                                <Form.Label>Interlocuteur</Form.Label>
                                <Select options={interlocuteurs}
                                    placeholder='Choisir interlocuteur...'
                                    classNamePrefix="react-select"
                                    value={valueInterlocuteur}
                                    onChange={value => {
                                        setValueInterlocuteur(value)
                                        let d = formd;
                                        d['interlocuteur'] = value;
                                        setFrom(d);
                                    }}
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} md="5" controlId="bookingorder">
                                <Form.Label>Status de la demande (requis)</Form.Label>
                                <Select
                                    required
                                    options={[
                                        { value: 'canceled', label: 'Annuler' },
                                        { value: 'created', label: 'En cours' },
                                        { value: 'confirmed', label: 'Confirmer' },
                                        { value: 'booked', label: 'Transformer en réservation' },
                                    ]}
                                    placeholder='Choisir le status...'
                                    classNamePrefix="react-select"
                                    value={valueStatut}
                                    onChange={value => {
                                        setValueStatut(value)

                                        let d = formd;
                                        d['statut'] = value;
                                        setFrom(d);

                                    }}
                                    isDisabled={formd?.canEdit === false}
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="5" controlId="bookingorder">
                                <Form.Label>Origine de la demande</Form.Label>
                                <Select
                                    closeMenuOnSelect={false}
                                    options={[
                                        { value: 'direct', label: 'Direct' },
                                        { value: 'website', label: 'Site Internet' },
                                        { value: 'partner', label: 'Partenaire' },
                                    ]}
                                    isDisabled={formd?.canEdit === false}
                                    placeholder="Choisir l'origine..."
                                    classNamePrefix="react-select"
                                    value={valueOrigin}
                                    onChange={value => {
                                        setValueOrigin(value)


                                        let d = formd;
                                        d['origin'] = value;
                                        setFrom(d);

                                    }}
                                />
                            </Form.Group>

                            <Form.Group as={Col} md="4" controlId="originid">
                                <Form.Label>Numéro de demande interne (id origin)</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formd.origin_id}
                                    name="origin_id"
                                    onChange={handleChange}
                                    placeholder="Identifiant interne"
                                    disabled={formd?.canEdit === false}
                                />
                            </Form.Group>



                            <Form.Group as={Col} md="4" controlId="total_pay">
                                <Form.Label>Prix total payée (en €)</Form.Label>
                                <Form.Control
                                    type="text"

                                    disabled={formd?.canEdit === false}
                                    value={formd.total_pay}
                                    name="total_pay"
                                    onChange={handleChange}
                                    placeholder="Tarif total de la réservation (ex: 590.90)"
                                />
                            </Form.Group>

                            <Form.Group as={Col} md="4" controlId="adultNbr">
                                <Form.Label>Nombre total d'adulte</Form.Label>
                                <Form.Control
                                    disabled={formd?.canEdit === false}
                                    type="number"
                                    value={formd.adultNbr}
                                    name="adultNbr"
                                    onChange={handleChange}
                                    placeholder="Nombre total d'adulte"
                                    min={1}
                                />
                            </Form.Group>


                            <Form.Group as={Col} md="4" controlId="kidsNbr">
                                <Form.Label>Nombre total d'enfant</Form.Label>
                                <Form.Control
                                    disabled={formd?.canEdit === false}
                                    type="number"
                                    name="kidsNbr"
                                    value={formd.kidsNbr}
                                    onChange={handleChange}
                                    placeholder="Nombre total d'enfant"
                                    min={0}
                                />
                            </Form.Group>


                            <Form.Group as={Col} md="4" controlId="roomsNbr">
                                <Form.Label>Nombre total de chambre</Form.Label>
                                <Form.Control
                                    disabled={formd?.canEdit === false}
                                    type="number"
                                    name="roomsNbr"
                                    value={formd.roomsNbr}
                                    onChange={handleChange}
                                    placeholder="Nombre total de chambre"
                                    min={0}
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="4" controlId="zone_geo">
                                <Form.Label>Zone géographique</Form.Label>
                                <Form.Control
                                    disabled={formd?.canEdit === false}
                                    type="text"
                                    name="zone_geo"
                                    value={formd.zone_geo}
                                    onChange={handleChange}
                                    placeholder="Indiquez la zone géographique souhaité"
                                />
                            </Form.Group>



                            <Form.Group as={Col} md="10" controlId="email">
                                <Form.Label>Email  (requis)</Form.Label>
                                <Form.Control
                                    disabled={formd?.canEdit === false}
                                    type="text"
                                    name="email"
                                    value={emails}
                                    onChange={handleChange}
                                    placeholder="Email du client "
                                    required
                                />
                                {formd?.canEdit !== false && (
                                    <Form.Text className="text-warning fs--1">
                                        Séparer par une virgule (ex: email@bohouse.com, email2@bohouse.com)
                                    </Form.Text>
                                )}

                            </Form.Group>

                            <Form.Group as={Col} md="4" controlId="phone">
                                <Form.Label>Téléphone</Form.Label>
                                <Form.Control
                                    disabled={formd?.canEdit === false}
                                    type="text"
                                    name="phone"
                                    value={formd.phone}
                                    onChange={handleChange}
                                    placeholder="Téléphone du client"
                                />
                            </Form.Group>

                            <Form.Group as={Col} md="3" controlId={`ScheduleStartDate`}>
                                <Form.Label>Check-in</Form.Label>

                                <DatePicker

                                    disabled={formd?.canEdit === false}
                                    showTimeSelect
                                    dateFormat="dd/MM/yyyy HH:ss"
                                    selected={checkIn}
                                    startDate={checkIn}
                                    endDate={checkOut}
                                    timeFormat="p"
                                    selectsStart
                                    onChange={newDate => {
                                        let d = formd;
                                        d['checkin'] = newDate;
                                        setFrom(d)
                                        setCheckIn(newDate)
                                    }}
                                    customInput={
                                        <CustomDateInput
                                            formControlProps={{
                                                placeholder: 'jj/mm/yy',
                                                //     ...register(`ScheduleStartDate${index}`)
                                            }}
                                        />
                                    }
                                />
                            </Form.Group>


                            <Form.Group as={Col} md="3" controlId={`ScheduleEndDate`}>
                                <Form.Label>Check-out</Form.Label>

                                <DatePicker
                                    disabled={formd?.canEdit === false}
                                    selected={checkOut}
                                    showTimeSelect
                                    minDate={checkIn}
                                    selectsEnd
                                    startDate={checkIn}
                                    endDate={checkOut}
                                    dateFormat="dd/MM/yyyy HH:ss"
                                    onChange={newDate => {
                                        let d = formd;
                                        d['checkout'] = newDate;
                                        setFrom(d)
                                        setCheckOut(newDate)
                                    }}
                                    customInput={
                                        <CustomDateInput
                                            formControlProps={{
                                                placeholder: 'jj/mm/yy',
                                                //     ...register(`ScheduleStartDate${index}`)
                                            }}
                                        />
                                    }
                                />
                            </Form.Group>
                            <hr className="mt-3" />


                            <Row className="mb-3">



                                <Form.Group as={Col} md="5" controlId="demand_date">
                                    <Form.Label>Date de la demande</Form.Label>
                                    <DatePicker
                                        disabled={formd?.canEdit === false}
                                        selected={demand_date}
                                        dateFormat="dd/MM/yyyy"
                                        onChange={newDate => {
                                            let d = formd;
                                            d['demand_date'] = newDate;
                                            setFrom(d)
                                            setDemand_Date(newDate)
                                        }}
                                        customInput={
                                            <CustomDateInput
                                                formControlProps={{
                                                    placeholder: 'jj/mm/yy',
                                                    //     ...register(`ScheduleStartDate${index}`)
                                                }}
                                            />
                                        }
                                    />
                                </Form.Group>
                            </Row>

                            <hr className="mt-3" />

                            <Form.Group as={Col} md="4" controlId="budget_week">
                                <Form.Label>Budget par semaine (€)</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="budget_week"
                                    disabled={formd?.canEdit === false}
                                    value={formd.budget_week}
                                    onChange={handleChange}
                                    placeholder="Indiquez le budget par semaine"
                                />
                            </Form.Group>


                            <hr className="mt-3" />
                            <Form.Group as={Col} md="7" controlId="villaPossible">
                                <Form.Label>Liste des biens souhaité</Form.Label>
                                {!isDnDMode && (<Select
                                    options={villas}
                                    closeMenuOnSelect={false}
                                    isMulti
                                    placeholder='Choisir les biens...'
                                    classNamePrefix="react-select"
                                    value={valueVillaPossible}
                                    onChange={value => {
                                        setValueVillaPossible(value)
                                        let d = formd;
                                        d['villaPossible'] = value;
                                        let l = clients.find((c) => c.value === formd.client?.value).lang || 'fr'


                                        value?.forEach((d) => {
                                            if (formd[d.label + '_info'] === undefined) {
                                                const dsdate = formd.checkin?.seconds ? formd.checkin.toDate() : new Date(formd.checkin)
                                                const mdsdate = dsdate.getMonth() + 1;
                                                const price = getPriceForMonth(mdsdate, d.data.prices);
                                                let type = d.data.type.label;
                                                let thEn = typehome.find((l) => l.label === type).en?.toLowerCase();
                                                const lastdate = formd.checkout?.seconds ? formd.checkout.toDate() : new Date(formd.checkout)

                                                // console.log('dsdate', dsdate, lastdate)

                                                let p = "La ";
                                                switch (type) {
                                                    case 'Appartement':
                                                        p = "L'";
                                                        break;
                                                    case 'Chalet':
                                                        p = "Le ";
                                                        break;
                                                    default:
                                                        break;
                                                }

                                                formd[d.label + '_info'] = l === 'fr' ? `${p}${type?.toLowerCase()} ${d.label} est disponible du ${formatDisponibilite(dsdate, lastdate, "fr-FR")} pour ${price ? price : "Non trouvé"} par semaine` : `The ${thEn} ${d.label} is available from ${formatDisponibilite(dsdate, lastdate, "en-US")} for ${price ? price : "Non trouvé"} per week`
                                            }
                                        })
                                        setFrom(d);

                                    }}
                                    isDisabled={formd?.canEdit === false}
                                />)}
                                <Form.Check
                                    type="checkbox"
                                    label="Activer le mode reorder"
                                    checked={isDnDMode}
                                    onChange={() => setIsDnDMode(!isDnDMode)}
                                    disabled={valueVillaPossible.length === 0} // Désactiver si aucune villa n'est sélectionnée
                                />
                                <DragDropContext onDragEnd={handleOnDragEnd}>
                                    {isDnDMode && ( // Assurez-vous que Droppable est rendu uniquement en mode DnD
                                        <Droppable droppableId="villas">
                                            {(provided) => (
                                                <div
                                                    {...provided.droppableProps}
                                                    ref={provided.innerRef}
                                                    style={{
                                                        padding: "10px",
                                                        background: "#f8f9fa",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    {valueVillaPossible.map((villa, index) => (
                                                        <Draggable key={villa.value} draggableId={villa.value} index={index}>
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    style={{
                                                                        ...provided.draggableProps.style,
                                                                        padding: "8px",
                                                                        margin: "5px 0",
                                                                        background: "#ffffff",
                                                                        border: "1px solid #ccc",
                                                                        borderRadius: "5px",
                                                                    }}
                                                                >
                                                                    {villa.label}
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    )}
                                </DragDropContext>
                            </Form.Group>

                            <Form.Group as={Col} md="4" controlId="rapport">
                                <Form.Label>Email list de la demande (save before)</Form.Label>
                                <Button
                                    color="primary"
                                    onClick={() => generatePDF()}
                                    disabled={lsendE}
                                >
                                    {lsendE ? 'Chargement ..' : "Envoyer un email au client"}
                                </Button>
                            </Form.Group>
                            {formd?.villaPossible?.length > 0 && (<>
                                <hr className="mt-3" />
                                <Form.Group as={Col} md="7" controlId="villaPossiblelist">
                                    <Form.Label>Liste des biens info email</Form.Label>
                                    {
                                        formd?.villaPossible?.map((vp) => {
                                            return <p>
                                                {vp?.label}
                                                <Form.Control
                                                    as="textarea"
                                                    style={{ height: '100px' }}
                                                    name={`${vp?.label}_info`}
                                                    disabled={formd?.canEdit === false}
                                                    value={formd[`${vp?.label}_info`]}
                                                    onChange={handleChange}
                                                    placeholder={`Indiquez le text libre pour ${vp?.label}`}
                                                />
                                            </p>
                                        })
                                    }

                                </Form.Group>
                            </>)}
                            {/* <Form.Group as={Col} md="3" controlId="rapport">
                   <Form.Label>PDF rapport de la demande</Form.Label>
                        <Button 
                            color="primary" 
                            onClick={() => generatePDF()}
                        >
                        Générer rapport
                        </Button>
                   </Form.Group>
                   <Form.Group as={Col} md="2" controlId="rapport">
                   <Form.Label>PDF rapport client</Form.Label>
                        <Button 
                            color="primary" 
                            onClick={() => generatePDFClient()}
                        >
                        Générer 
                        </Button>
                   </Form.Group> */}

                            <hr className="mt-3" />
                            <Form.Group as={Col} md="10" controlId="equipment">
                                <Form.Label>Equipements demandé</Form.Label>
                                <Select
                                    closeMenuOnSelect={false}
                                    isMulti
                                    isDisabled={formd?.canEdit === false}
                                    options={equipements}
                                    placeholder='Choisir les équipements ...'
                                    classNamePrefix="react-select"
                                    value={valueEquipment}
                                    onChange={value => {
                                        setValueEquipment(value)
                                        let d = formd;
                                        d['equipments'] = value;
                                        setFrom(d);
                                    }}
                                />
                                {formd?.canEdit !== false && (<Form.Text className="text-warning fs--1">
                                    <p>pas dans la liste, <a target="_blank" href="/equiment/new">Ajouté</a>
                                        <IconButton
                                            variant="falcon-default"
                                            size="sm"
                                            //   icon="reload"
                                            className="me-1 mb-2 mb-sm-0"
                                            iconClassName="me-1"
                                            onClick={() => { loadList() }}>
                                            recharger la liste d'equipement
                                        </IconButton></p>


                                </Form.Text>)}

                            </Form.Group>
                            <hr style={{ marginTop: 10 }} />


                            <Row className="mb-3">
                                <Form.Label>Services demandé par le client</Form.Label>
                                {
                                    services?.map((service, index) => {
                                        return (<Row className="mb-3">



                                            <Form.Group as={Col} md="3" controlId="pricePer">
                                                <Form.Label>Service</Form.Label>
                                                <Select
                                                    options={
                                                        servicesList
                                                    }
                                                    isDisabled={formd?.canEdit === false}
                                                    placeholder='Choisir...'
                                                    classNamePrefix="react-select"
                                                    value={service?.service}
                                                    onChange={(value) => {
                                                        let o = [...services];
                                                        let m = { ...service };
                                                        m.service = value
                                                        o[index] = m;
                                                        setServices(o);
                                                        let d = { ...formd };
                                                        d['services'] = o;
                                                        setFrom(d);
                                                    }}
                                                />
                                            </Form.Group>
                                            <Form.Group as={Col} md="3" className="mb-3">
                                                <Form.Label>Titre</Form.Label>
                                                <Form.Control
                                                    name={`serviceTitle_${index}`}
                                                    placeholder="Titre"
                                                    value={service.title}
                                                    disabled={formd?.canEdit === false}
                                                    onChange={(e) => {
                                                        let o = [...services];
                                                        let m = { ...service };
                                                        m.title = e.target.value
                                                        o[index] = m;
                                                        setServices(o);
                                                        let d = { ...formd };
                                                        d['services'] = o;
                                                        setFrom(d);
                                                    }}
                                                />
                                            </Form.Group>

                                            <Form.Group as={Col} md="5" controlId="description">
                                                <Form.Label>Description</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    disabled={formd?.canEdit === false}
                                                    value={service?.description}
                                                    name={`serviceDescription_${index}`}
                                                    onChange={(e) => {
                                                        let o = [...services];
                                                        let m = { ...service };
                                                        m.description = e.target.value
                                                        o[index] = m;
                                                        setServices(o);
                                                        let d = { ...formd };
                                                        d['services'] = o;
                                                        setFrom(d);
                                                    }}
                                                    placeholder="Description du service ..."
                                                />
                                            </Form.Group>

                                            {formd?.canEdit !== false && (

                                                <IconButton as={Col} md="1" onClick={() => {
                                                    let arr = services;
                                                    arr.splice(index, 1);
                                                    setServices(arr);
                                                    let d = { ...formd };
                                                    d['services'] = arr;
                                                    setFrom(d);
                                                }}
                                                    variant="falcon-danger"
                                                    size="sm"
                                                    icon="trash"
                                                    transform="shrink-3"
                                                    className='me-2'
                                                    style={{ width: 60, height: 25, marginTop: 35 }}
                                                >
                                                </IconButton>
                                            )}

                                        </Row>)
                                    })
                                }
                                {formd?.canEdit !== false && (
                                    <div>
                                        <Flex
                                            alignItems="center"
                                            className="mb-4 text-primary cursor-pointer fs-0"
                                            onClick={() => {
                                                let o = [...services];
                                                if (o[o.length - 1]?.title?.trim() !== "" && o[o.length - 1]?.description?.trim() !== "") {
                                                    o.push({ service: null, title: "", description: "" });
                                                    setServices(o);
                                                }
                                            }}
                                        >
                                            <span className="circle-dashed">
                                                <FontAwesomeIcon icon="plus" />
                                            </span>
                                            <span className="ms-3">Ajouter un nouveau service</span>
                                        </Flex>
                                    </div>)}

                                {services[services?.length - 1]?.service === null && formd?.canEdit !== false && (
                                    <Form.Text className="text-warning fs--1">
                                        <p>pas dans la liste, <a target="_blank" href="/service/new">Ajouté</a> <IconButton
                                            variant="falcon-default"
                                            size="sm"
                                            // icon="reload"
                                            className="me-1 mb-2 mb-sm-0"
                                            iconClassName="me-1"
                                            onClick={() => { loadList() }}>
                                            recharger la liste des services
                                        </IconButton></p>
                                    </Form.Text>
                                )}



                            </Row>


                            <hr className="mt-3" />
                            <Form.Label>Commentaire</Form.Label>
                            <Form.Group className="mb-3">

                                <Form.Control as="textarea" name="comment"
                                    placeholder="Laisser un commentaire ici"
                                    style={{ height: '100px' }}
                                    value={formd.comment}

                                    disabled={formd?.canEdit === false}
                                    onChange={handleChange}
                                />
                            </Form.Group>




                        </Row>


                        {formd?.canEdit === false
                            ? (<Button onClick={() => {
                                navigate('/booking/edit/' + formd?.bookedId);
                            }}>
                                Voir la réservation
                            </Button>)
                            : (<Button type="submit" disabled={l}>{l ? 'Chargement' : 'Modifier'}</Button>)}

                    </Form>
                ) : <p>Chargement ...</p>}
            </FalconComponentCard.Body>


        </FalconComponentCard>


        <FalconComponentCard>
            <FalconComponentCard.Header title={'Suivis de la demande'} light={false} noPreview={true} />
            <FalconComponentCard.Body>
                <LogTable />
            </FalconComponentCard.Body>
        </FalconComponentCard>

        {/* Modal d'ajout d'un nouveau client */}
        <Modal fullscreen show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Ajouter un nouveau client</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Newucrm canRedirect={false} redirectHere={(value) => {
                    let clientsm = clients
                    clientsm.push(value);
                    let d = formd;
                    d['client'] = value;
                    setFrom(d);
                    if (valueClientId?.value !== value.value) {
                        // si changement de client on efface email et on réinit
                        let f = formd
                        f['email'] = undefined;
                        setFrom(f);
                        setEmails('')
                    }
                    setValueClientId(value)
                    if (formd['email'] === undefined) {
                        let id = value.value
                        clientsm.forEach(d => {
                            if (d.value === id) {
                                let f = formd
                                f['email'] = d.email
                                setFrom(f);
                                setEmails(d.email)
                            }
                        })
                    }
                    setClients(clientsm)
                    if (formd.initializevilla) {
                        initializevilla(value)
                    }
                    setShowModal(false)
                }} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                    Fermer
                </Button>
            </Modal.Footer>
        </Modal>
    </>

    );
};

export default EditDemand;
